module.exports = __webpack_public_path__ + "img/kolobox-logo.e0676ec6.jpeg";